/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type CalendarStatusResponse = "AfterHours" | "BeforeWorkingHours" | "DayOff" | "FocusTime" | "Holiday" | "Lunch" | "Meeting" | "Other" | "OutOfOffice" | "Weekend" | "WorkingHours" | "%future added value";
export type MoonPhase = "FirstQuarterMoon" | "FullMoon" | "LastQuarterMoon" | "NewMoon" | "WaningCrescentMoon" | "WaningGibbousMoon" | "WaxingCrescentMoon" | "WaxingGibbousMoon" | "%future added value";
export type CalendarStatus_calendarStatus = {
    readonly status: CalendarStatusResponse | null;
    readonly moonPhase: MoonPhase | null;
    readonly " $refType": "CalendarStatus_calendarStatus";
};
export type CalendarStatus_calendarStatus$data = CalendarStatus_calendarStatus;
export type CalendarStatus_calendarStatus$key = {
    readonly " $data"?: CalendarStatus_calendarStatus$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"CalendarStatus_calendarStatus">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarStatus_calendarStatus",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "moonPhase",
            "storageKey": null
        }
    ],
    "type": "CalendarStatus",
    "abstractKey": null
} as any;
(node as any).hash = '22bc3f66c342a42b2dd5da28c52621bd';
export default node;
